import { useEffect } from 'react'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { collaborationState } from 'Pages/MessageList/recoil/state/results'

import { fetchCollaborationCallback } from 'Pages/MessageList/recoil/callbacks/callbacks'

const useCollaboration = () => {
  const ids = useRecoilValue(collaborationState)
  const fetchCollaboration = useRecoilCallback(fetchCollaborationCallback, [])

  useEffect(() => {
    fetchCollaboration()
  }, [ids])
}

export default useCollaboration
